<h4 class="">
  <p class="text-center">Klanten</p>
</h4>
<div class="row ui-toolbar">
  <div class="col-7">
    <input type="text" pInputText class="form-control" size="50" placeholder="Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
  </div>

  <div class="col-5">
    <div class="pull-right btn-toolbar">
      <button type="button" class="btn btn-success" (click)="addCustomer()">
        Toevoegen
      </button>
    </div>
  </div>
</div>

<p-table #dt [columns]="cols" [value]="customers" [paginator]="true" [rows]="10" selectionMode="single" [(selection)]="selectedCustomer">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        {{rowData[col.field]}}
      </td>
    </tr>
  </ng-template>
</p-table>



// WEBPACK FOOTER //
// ./src/app/pages/customer/customers.component.html